import "../../../../content/blog/2018-06-21-lean-from-trenches.css";
import React from 'react';
export default {
  React
};